/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from "react";
import CategoryFilter from "./CategoryFilter";
import DiscountFilter from "./DiscountFilter";
import ClearFilter from "./ClearFilter";
import TrendingCardHeader from "./TrendingCardHeader";
// import TrendingGiftCard from "./TrendingGiftCard";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import EarnPointsModal from "./modal";
import Loader from "../Loader/Loader";
import { useRef } from "react";
import SortBy from "./SortBy";
import { setFilteredAddSpecialActive } from "../../Store/Slices/trendingGiftCradsSlice";
import FilterIcon from "../../Assets/filter-icon.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  getProductList,
  getProductListTrending,
} from "../../Store/Slices/productSlice";
import TrendingGiftCardOptimized from "./TrendingGiftCardOptimized";
import { LoginReducerData, LoginV3Data, trackEvent } from "../Utility/Utility";
import { onGetClientCapping } from "../../Store/Slices/clientCappingSlice";
import { encryptURLParam, decryptURLParam } from "../../Common/Axios/encrypt";
import { onGetCustomerProduct } from "../../Store/Slices/customerProductSummarySlice";
import CustomLoader from "../CustomLoader/CustomLoader";
import { use } from "react";
import DiscountFilterNew from "./DiscountFilterNew";
import Redeemable from "./Redeemable";
import { setProduct } from "../../Store/Slices/productDataSlice";
const ProductListOptimized = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const translation = getTranslationData();
  const [displaySort, setDisplaySort] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [products, setProducts] = useState();
  const [allProducts, setAllProducts] = useState();
  const [category, setCategory] = useState([]);
  const [categoryName, setCategoryName] = useState([]);
  const [discount, setDiscount] = useState();
  const [maxDiscount, setMaxDiscount] = useState(0);
  const [selectedSort, setSelectedSort] = useState();
  const [prevUrl, setPrevUrl] = useState("");
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);

  const handleShow = () => !isOpen && setShowModal(true);
  const [modalData, setModalData] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [maxDiscountValue, setMaxDiscountValue] = useState(0);
  const loginReducerData = LoginReducerData();
  const url = new URL(window.location.href);
  const trending = url.searchParams.get("trending");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const hasTracked = useRef(false);
  const searchLoaderRef = useRef(null);
  const searchContainerRef = useRef(null);
  const modalSearchContainerRef = useRef(null);
  const [filteredResults, setFilteredResults] = useState([]);
  const [hasMoreSearchResults, setHasMoreSearchResults] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [NoResultFoundMessage, setNoResultFoundMessage] = useState(false);
  const [brand_availableMessage, setbrand_availableMessage] = useState(false);
  const categoryAllData = useSelector(
    (state) => state.userRoleSliceReducer.categoryData,
  );
  const supplierCappingList = useSelector(
    (state) => state?.clientCappingSliceReducer?.clientCappingData,
  );
  const [isSearching, setIsSearching] = useState(false);

  // inside your component
  const debounceRef = useRef(null);
  const [searchFilterList, setSearchFilterList] = useState([]);
  // updated handler
  const handleChangeOptimized = (e) => {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);
    setIsSearching(true);
    setIsSearchActive(true);

    // Cancel pending debounce
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    // Empty input -> reset
    if (searchValue.trim() === "") {
      setFilteredResults([]);
      setIsSearchActive(false);
      setPageNumber(1);
      setHasMoreSearchResults(true);
      setIsSearching(false);
      return;
    }

    // Only search when 3+ chars
    if (searchValue.trim().length >= 3) {
      // Reset for new search
      setPageNumber(1);
      setHasMoreSearchResults(true);
      // Debounce the API call
      debounceRef.current = setTimeout(() => {
        const result = products.filter((product) => {
          return product.name.toLowerCase().includes(searchValue.toLowerCase());
        });

        if (result.length > 0) {
          setSearchFilterList(result);
        }

        const payload = {
          search: searchValue,
          pageNumber: 1,
          pageSize: 10,
        };
        if (result.length === 0) {
          dispatch(getProductList(payload)).then((response) => {
            let searchwithoutFilter = [];
            if (response?.payload?.response?.products?.length > 0) {
              searchwithoutFilter = response?.payload?.response?.products;
            }
            setSearchFilterList(searchwithoutFilter);
            setHasMoreSearchResults(
              response?.payload?.response?.totalCount >
              searchwithoutFilter.length,
            );
            setbrand_availableMessage(true);
            searchwithoutFilter.length > 0
              ? setNoResultFoundMessage(false)
              : setNoResultFoundMessage(true);
          });
        } else {
          setNoResultFoundMessage(true);
          setbrand_availableMessage(false);
        }
      }, 250);
    } else {
      // fewer than 3 chars -> reset suggestions
      setFilteredResults([]);
      setPageNumber(1);
      setHasMoreSearchResults(true);
      setIsSearching(false);
    }
  };

  useEffect(() => {
    if (
      supplierCappingList?.length === 0 ||
      supplierCappingList === undefined
    ) {
      dispatch(onGetClientCapping(parseInt(loginReducerData?.clientId)));
    }
  }, []);
  // Memoize category mapping for performance
  const categoryMap = useMemo(() => {
    if (!Array.isArray(categoryAllData)) return {};
    return categoryAllData.reduce((acc, cat) => {
      acc[cat.name] = cat;
      return acc;
    }, {});
  }, [categoryAllData]);

  // --- helper functions for discount & redeemable client-side filtering ---
  const parseDiscountTokensToRanges = (tokenString) => {
    if (!tokenString) return [];

    const tokens = String(tokenString)
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);

    return tokens
      .map((t) => {
        if (t === "1" || t === "0-5")
          return { min: 0, max: 5, includeMin: true, includeMax: true };

        if (t === "2" || t === "5-10")
          return { min: 5, max: 10, includeMin: false, includeMax: true };

        if (t === "3" || t === "10+")
          return {
            min: 10,
            max: Infinity,
            includeMin: false,
            includeMax: true,
          };

        return null;
      })
      .filter(Boolean);
  };

  const getProductDiscountValue = (p) => {
    const candidates = [
      p?.customerDiscount,
      p?.discount,
      p?.customerDiscountPercent,
      p?.clientDiscount,
      p?.discountPercentage,
    ];

    for (const c of candidates) {
      if (c === null || c === undefined || c === "") continue;

      const n = Number(c);

      if (Number.isFinite(n) && n >= 0) {
        return n;
      }
    }

    // if no discount field exists or all are empty → treat as 0%
    return 0;
  };

  const parseRedeemableTokens = (token) => {
    if (!token) return [];
    return String(token)
      .split(",")
      .map((s) => parseInt(s.trim(), 10))
      .filter((n) => !Number.isNaN(n));
  };

  const productRedeemableEnums = (p) => {
    const raw =
      p?.redeemable ||
      p?.redemptionType ||
      p?.redeemType ||
      p?.redemption ||
      p?.redeemableType;
    if (raw === undefined || raw === null) return [];
    if (typeof raw === "number") return [raw];
    if (typeof raw === "string") {
      const s = raw.trim().toLowerCase();
      if (s === "online") return [1];
      if (s === "offline" || s === "in-store" || s === "instore") return [2];
      if (s === "both" || s === "online & offline") return [3];
      const tokens = s
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);
      const nums = tokens
        .map((t) => parseInt(t, 10))
        .filter((n) => !Number.isNaN(n));
      if (nums.length) return nums;
    }
    if (Array.isArray(raw)) {
      return raw
        .map((item) => {
          if (typeof item === "number") return item;
          if (typeof item === "string") {
            const st = item.trim().toLowerCase();
            if (st === "online") return 1;
            if (st === "offline" || st === "in-store") return 2;
            if (st === "both") return 3;
            const n = parseInt(st, 10);
            return Number.isNaN(n) ? null : n;
          }
          return null;
        })
        .filter(Boolean);
    }
    return [];
  };

  const applyFiltersToProducts = (
    productsList,
    decryptedDiscountParam,
    decryptedRedeemableParam,
  ) => {
    let results = productsList || [];

    // discount filter (OR across selected slabs)
    if (decryptedDiscountParam) {
      const discountRanges = parseDiscountTokensToRanges(
        decryptedDiscountParam,
      );

      if (discountRanges.length) {
        results = results.filter((p) => {
          const val = getProductDiscountValue(p);

          // if product has no discount, exclude it when filter is active
          if (val === null) return false;

          return discountRanges.some((r) => {
            const minOk = r.includeMin ? val >= r.min : val > r.min;
            const maxOk =
              r.max === Infinity
                ? true
                : r.includeMax
                  ? val <= r.max
                  : val < r.max;

            return minOk && maxOk;
          });
        });
      }
    }

    // redeemable filter (multi-select OR). Products lacking redeemable info are excluded when a redeemable filter is active.
    if (decryptedRedeemableParam) {
      const selectedEnums = parseRedeemableTokens(decryptedRedeemableParam);
      if (selectedEnums.length) {
        results = results.filter((p) => {
          const pEnums = productRedeemableEnums(p); // [] or [1] or [3] etc
          if (!pEnums.length) return false; // exclude unknown when filter active (AC7 -> shown only under All)
          // if product is Both (3) treat as matching any selection
          return selectedEnums.some(
            (sel) => pEnums.includes(sel) || pEnums.includes(3),
          );
        });
      }
    }
    return results;
  };

  // sort payload helper: returns { sortBy, sortOrder } or {}
  const getSortPayload = (sortKey) => {
    if (!sortKey) return {};
    const raw = String(sortKey);
    const k = raw.toLowerCase();
    // alphabet -> ascending; others -> descending (Discount, TopPicks)
    if (k === "name-asc") return { sortBy: raw, sortOrder: "asc" };
    return { sortBy: raw, sortOrder: "desc" };
  };
  // --- end helpers ---
  // Category List and Selected Category
  const [checkedCategories, setCheckedCategories] = useState([]);
  const [checkedCategoryName, setCheckedCategoryName] = useState([]);
  // Redeemable state should be a multi-select array (checkboxes)
  const [checkedRedeemable, setCheckedRedeemable] = useState([]);
  const [placeholder] = useState(translation?.searchbybrand);
  const [isSearchActive, setIsSearchActive] = useState(false);
  // Sync state with URL or defaultData
  // Merge: Sync state with URL, handle filter/sort changes, and make API call
  // Prevent multiple API calls by using a ref to track the last API call params
  const lastApiCallParams = useRef({});
  const apiCallDebounceRef = useRef(null);
  const isApiCallInProgress = useRef(false);

  // Separate effect for syncing URL params to state (without triggering API)
  // This effect only updates state, API calls happen in the next effect
  useEffect(() => {
    if (!categoryAllData) return;

    const queryParams = new URLSearchParams(location.search);

    // Read and decrypt all URL params
    const encryptedRedemptionType =
      queryParams.get("redemptionType") || queryParams.get("redeemable");
    const encryptedDiscountSlab = queryParams.get("discountSlab");
    const encryptedSortOrder =
      queryParams.get("sortOrder") || queryParams.get("sortBy");
    const encryptedDiscount = queryParams.get("discount");

    const redemptionTypeParam = encryptedRedemptionType
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedRedemptionType
        : decryptURLParam(encryptedRedemptionType)
      : null;
    const discountSlabParam = encryptedDiscountSlab
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedDiscountSlab
        : decryptURLParam(encryptedDiscountSlab)
      : null;
    const sortOrderParam = encryptedSortOrder
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedSortOrder
        : decryptURLParam(encryptedSortOrder)
      : null;
    const discountParam = encryptedDiscount
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedDiscount
        : decryptURLParam(encryptedDiscount)
      : null;

    // Sync params to state - React will handle optimization
    setCheckedRedeemable(
      redemptionTypeParam ? String(redemptionTypeParam) : "",
    );

    // Prefer discountSlab over discount param
    if (discountSlabParam !== null) {
      setDiscount(discountSlabParam);
    } else if (discountParam !== null) {
      setDiscount(discountParam);
    } else {
      // Clear discount if not in URL
      setDiscount(undefined);
    }

    // Update sort if param exists, otherwise clear it
    setSelectedSort(sortOrderParam || "");
  }, [location.search, categoryAllData]);

  // Main effect for API calls - only triggers after state is synced
  useEffect(() => {
    if (!categoryAllData) return;

    // Clear any pending debounce
    if (apiCallDebounceRef.current) {
      clearTimeout(apiCallDebounceRef.current);
      apiCallDebounceRef.current = null;
    }

    const queryParams = new URLSearchParams(location.search);

    // Decrypt all URL parameters
    const encryptedCategoryId = queryParams.get("categoryId");
    const encryptedDiscount = queryParams.get("discount");
    const encryptedTrending = queryParams.get("trending");
    const encryptedSpecialId = queryParams.get("specialId");
    const encryptedSearch = queryParams.get("search");
    const encryptedRedemptionType =
      queryParams.get("redemptionType") || queryParams.get("redeemable");
    const encryptedDiscountSlab = queryParams.get("discountSlab");
    const encryptedSortOrder =
      queryParams.get("sortOrder") || queryParams.get("sortBy");

    const allCId = encryptedCategoryId
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedCategoryId
        : decryptURLParam(encryptedCategoryId)
      : null;
    const discountParam = encryptedDiscount
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedDiscount
        : decryptURLParam(encryptedDiscount)
      : null;
    const trending = encryptedTrending
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedTrending
        : decryptURLParam(encryptedTrending)
      : null;
    const specialId = encryptedSpecialId
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedSpecialId
        : decryptURLParam(encryptedSpecialId)
      : null;
    const search = encryptedSearch
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedSearch
        : decryptURLParam(encryptedSearch)
      : null;
    const redemptionTypeParam = encryptedRedemptionType
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedRedemptionType
        : decryptURLParam(encryptedRedemptionType)
      : null;
    const discountSlabParam = encryptedDiscountSlab
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedDiscountSlab
        : decryptURLParam(encryptedDiscountSlab)
      : null;
    const sortOrderParam = encryptedSortOrder
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedSortOrder
        : decryptURLParam(encryptedSortOrder)
      : null;

    const decryptedDiscountForFiltering = discountParam || discountSlabParam;
    const finalDiscountValue = discountSlabParam || discountParam;

    // Check if we need to wait for dependencies
    const hasCategoryInUrl = allCId !== null;
    const hasDiscountInUrl =
      discountParam !== null || discountSlabParam !== null;

    // If category is in URL, we need categoryMap to be ready
    if (hasCategoryInUrl) {
      if (!categoryMap || Object.keys(categoryMap).length === 0) {
        return; // Wait for categoryMap to be ready
      }
    }

    if (trending && !specialId) {
      return;
    }

    const triggerApi = () => {
      // Prevent duplicate calls
      if (isApiCallInProgress.current) {
        return;
      }

      let selectedCategories = [];
      let updatedCheckedCategoryData = [];
      let selectedCategoryId = "";

      if (allCId) {
        selectedCategories = decodeURIComponent(allCId).split(",");

        // First try to find by name (categoryMap key is name)
        updatedCheckedCategoryData = selectedCategories.flatMap((cId) => {
          const cat = categoryMap[cId];
          return cat ? [cat] : [];
        });

        // If not found by name, try to find by value or id
        if (updatedCheckedCategoryData.length === 0 && categoryMap) {
          updatedCheckedCategoryData = Object.values(categoryMap).filter(
            (cat) =>
              selectedCategories.includes(String(cat.value)) ||
              selectedCategories.includes(String(cat.name)) ||
              selectedCategories.includes(String(cat.id)),
          );
        }

        setCheckedCategories(selectedCategories);
        setCategory(updatedCheckedCategoryData);
        setCategoryName(selectedCategories);

        // Use found categories' IDs, or if not found, try using the categoryId directly (might already be IDs)
        if (updatedCheckedCategoryData.length > 0) {
          selectedCategoryId = updatedCheckedCategoryData
            .map((cat) => cat.id)
            .join(",");
        } else {
          // If no match found in categoryMap, assume categoryId in URL is already in ID format
          // This handles cases where categoryId might be numeric IDs
          selectedCategoryId = selectedCategories.join(",");
        }
      } else {
        setCheckedCategories([]);
        setCategory([]);
        setCategoryName([]);
        selectedCategoryId = "";
      }

      // Build payload - use URL params as source of truth
      const finalRedeemable = redemptionTypeParam || null;
      const finalSort = sortOrderParam || "";

      const payloadBase = {
        pageNumber: 1,
        pageSize: 20,
        categoryId: selectedCategoryId,
        discountSlab: finalDiscountValue || null,
        redeemable: finalRedeemable,
        ...getSortPayload(finalSort),
      };

      if (search) payloadBase.search = search;
      if (finalDiscountValue) {
        payloadBase.minDiscount = finalDiscountValue;
        payloadBase.maxDiscount = maxDiscount || 0;
      }

      // Create a stable key for deduplication
      const paramsKey = JSON.stringify({
        categoryId: selectedCategoryId,
        discountSlab: finalDiscountValue,
        redeemable: finalRedeemable,
        sort: finalSort,
        search,
        trending,
        specialId,
        pageNumber: 1,
      });

      // Skip if this exact call was already made
      if (lastApiCallParams.current.key === paramsKey) {
        return;
      }

      lastApiCallParams.current.key = paramsKey;
      isApiCallInProgress.current = true;
      setLoading(true);

      const apiCall = trending
        ? dispatch(getProductListTrending({ ...payloadBase, specialId }))
        : dispatch(getProductList(payloadBase));

      apiCall
        .then((response) => {
          const newProducts = response?.payload?.response?.products || [];
          // Use URL params directly for filtering
          const decryptedRedeemableForFiltering = redemptionTypeParam;

          const finalProducts = applyFiltersToProducts(
            newProducts,
            decryptedDiscountForFiltering,
            decryptedRedeemableForFiltering,
          );
          setProducts(finalProducts);
          setTotalCount(response?.payload?.response?.totalCount);
          setMaxDiscountValue(response?.payload?.response?.maxDiscount || 0);
          setLoading(false);
          isApiCallInProgress.current = false;
        })
        .catch(() => {
          setLoading(false);
          isApiCallInProgress.current = false;
        });
    };

    // Debounce API call by 300ms to batch rapid filter changes
    apiCallDebounceRef.current = setTimeout(() => {
      triggerApi();
      apiCallDebounceRef.current = null;
    }, 300);

    return () => {
      if (apiCallDebounceRef.current) {
        clearTimeout(apiCallDebounceRef.current);
        apiCallDebounceRef.current = null;
      }
    };
    // eslint-disable-next-line
  }, [
    categoryAllData,
    location.search,
    categoryMap,
    // Removed discount from dependencies to prevent loops
    // State sync happens in separate effect above
  ]);

  // Fix: Get categoryId from location or another valid source, or import productReducer from Redux
  const encryptedCategoryId = new URLSearchParams(location.search).get(
    "categoryId",
  );
  const CategoryId = encryptedCategoryId
    ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
      ? encryptedCategoryId
      : decryptURLParam(encryptedCategoryId)
    : null;

  // Separate useEffect for pagination (infinite scroll)
  useEffect(() => {
    if (pageNumber > 1) {
      // Check if we already have all available products
      if (products && totalCount > 0 && products.length >= totalCount) {
        return; // Don't make API call if we have all products
      }



      // Conditionally decrypt the categoryId parameter based on environment setting
      const encryptedCategoryValue = url.searchParams.get("categoryId");
      const categoryValue = encryptedCategoryValue
        ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
          ? encryptedCategoryValue
          : decryptURLParam(encryptedCategoryValue)
        : null;
      let selectedCategoryId = "";

      if (
        (categoryValue && Array.isArray(category) && category.length > 0) ||
        (categoryValue && !Array.isArray(categoryMap))
      ) {
        const categoryValues = categoryValue.split(",");
        const foundCategories =
          category?.length > 0
            ? category?.filter(
              (cat) =>
                categoryValues.includes(String(cat.value)) ||
                categoryValues.includes(String(cat.name)) ||
                categoryValues.includes(String(cat.id)),
            )
            : categoryMap
              ? Object.values(categoryMap).filter(
                (cat) =>
                  categoryValues.includes(String(cat.value)) ||
                  categoryValues.includes(String(cat.name)) ||
                  categoryValues.includes(String(cat.id)),
              )
              : [];
        selectedCategoryId = foundCategories.map((cat) => cat.id).join(",");
      } else {
        selectedCategoryId =
          Array.isArray(category) && category.length > 0 ? category[0].id : "";
      }

      // Conditionally decrypt trending and specialId parameters based on environment setting
      const encryptedTrending = url.searchParams.get("trending");
      const decryptedTrending = encryptedTrending
        ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
          ? encryptedTrending
          : decryptURLParam(encryptedTrending)
        : null;

      if (decryptedTrending) {
        const encryptedSpecialId = url.searchParams.get("specialId");
        const specialId = encryptedSpecialId
          ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
            ? encryptedSpecialId
            : decryptURLParam(encryptedSpecialId)
          : null;
        const payload = {
          specialId,
          pageNumber: pageNumber,
          pageSize: 20,
          categoryId: selectedCategoryId,
          discountSlab: discount,
          redeemable: checkedRedeemable,
          // include sortBy & sortOrder based on selectedSort
          ...getSortPayload(selectedSort),
        };
        if (discount) {
          payload.minDiscount = discount;
          payload.maxDiscount = maxDiscount || 0;
        }
        dispatch(getProductListTrending(payload)).then((response) => {
          const newProducts = response?.payload?.response?.products || [];
          const totalRecords = response?.payload?.response?.totalCount || 0;



          //setTotalCount(totalRecords);

          if (pageNumber === 1) {
            setProducts(newProducts);
          } else {
            setProducts((prev) => {
              const currentProducts = prev || [];

              if (currentProducts.length >= totalRecords) {
                return currentProducts;
              }
              const combinedProducts = [...currentProducts, ...newProducts];
              return combinedProducts.slice(0, totalRecords);
            });
          }
          setMaxDiscountValue(response?.payload?.response?.maxDiscount || 0);
        });
      } else {
        const payload = {
          pageNumber: pageNumber,
          pageSize: 20,
          categoryId: selectedCategoryId,
          discountSlab: discount,
          redeemable: checkedRedeemable,
          // include sortBy & sortOrder based on selectedSort
          ...getSortPayload(selectedSort),
          search: url.searchParams.get("search")
            ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
              ? url.searchParams.get("search")
              : decryptURLParam(url.searchParams.get("search"))
            : null,
        };
        if (discount) {
          payload.minDiscount = discount;
          payload.maxDiscount = maxDiscount || 0;
        }
        dispatch(getProductList(payload)).then((response) => {
          const newProducts = response?.payload?.response?.products || [];
          const totalRecords = response?.payload?.response?.totalCount || 0;



          //setTotalCount(totalRecords);

          if (pageNumber === 1) {
            setProducts(newProducts);
          } else {
            setProducts((prev) => {
              const currentProducts = prev || [];
              // Don't add more products if we already have all available records
              if (currentProducts.length >= totalRecords) {
                return currentProducts;
              }
              // Only add products that don't exceed total count
              const combinedProducts = [...currentProducts, ...newProducts];
              return combinedProducts.slice(0, totalRecords);
            });
          }
          setMaxDiscountValue(response?.payload?.response?.maxDiscount || 0);
        });
      }
    }
  }, [pageNumber]);

  // Handle sorting changes - reset page number and update product list
  useEffect(() => {
    if (selectedSort && categoryAllData) {

      setPageNumber(1);
      setProducts([]); // Clear current products

      // Get current URL parameters for API call
      const queryParams = new URLSearchParams(location.search);
      const encryptedCategoryId = queryParams.get("categoryId");
      const encryptedTrending = queryParams.get("trending");
      const encryptedSpecialId = queryParams.get("specialId");
      const encryptedSearch = queryParams.get("search");

      // Decrypt parameters
      const categoryId = encryptedCategoryId
        ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
          ? encryptedCategoryId
          : decryptURLParam(encryptedCategoryId)
        : null;
      const trending = encryptedTrending
        ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
          ? encryptedTrending
          : decryptURLParam(encryptedTrending)
        : null;
      const specialId = encryptedSpecialId
        ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
          ? encryptedSpecialId
          : decryptURLParam(encryptedSpecialId)
        : null;
      const search = encryptedSearch
        ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
          ? encryptedSearch
          : decryptURLParam(encryptedSearch)
        : null;

      let selectedCategories = [];
      let updatedCheckedCategoryData = [];
      let selectedCategoryId = "";

      if (categoryId) {
        selectedCategories = decodeURIComponent(categoryId).split(",");
        updatedCheckedCategoryData = selectedCategories.flatMap((cId) => {
          const cat = categoryMap[cId];
          return cat ? [cat] : [];
        });
        setCheckedCategories(selectedCategories);
        setCategory(updatedCheckedCategoryData);
        setCategoryName(selectedCategories);

        // For API payload
        const foundCategories =
          updatedCheckedCategoryData.length > 0
            ? updatedCheckedCategoryData
            : categoryMap
              ? Object.values(categoryMap).filter(
                (cat) =>
                  selectedCategories.includes(String(cat.value)) ||
                  selectedCategories.includes(String(cat.name)) ||
                  selectedCategories.includes(String(cat.id)),
              )
              : [];
        selectedCategoryId = foundCategories.map((cat) => cat.id).join(",");
      } else {
        setCheckedCategories([]);
        setCategory([]);
        setCategoryName([]);
        selectedCategoryId = "";
      }
      // Prepare API payload
      const payloadBase = {
        pageNumber: 1,
        pageSize: 20,
        categoryId: selectedCategoryId || "",
        discountSlab: discount,
        redeemable: checkedRedeemable,
        // include sortBy & sortOrder based on selectedSort
        ...getSortPayload(selectedSort),
      };

      if (search) payloadBase.search = search;
      if (discount) {
        payloadBase.minDiscount = discount;
        payloadBase.maxDiscount = maxDiscount || 0;
      }
      // Make API call based on trending or regular products
      setLoading(true);
      const apiCall = trending
        ? dispatch(getProductListTrending({ ...payloadBase, specialId }))
        : dispatch(getProductList(payloadBase));

      apiCall
        .then((response) => {
          const newProducts = response?.payload?.response?.products || [];
          setProducts(newProducts);
          setTotalCount(response?.payload?.response?.totalCount || 0);
          setMaxDiscountValue(response?.payload?.response?.maxDiscount || 0);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [selectedSort]);

  const updatePageNumber = () => {
    setPageNumber(1);
    return 1;
  };
  const productData = useSelector((state) =>
    state.productReducer.productById?.[0]?.products?.filter(
      (product) => product.enabled === true,
    ),
  );

  const productDiscount = useSelector(
    (state) =>
      state?.ClientProductMappingbyIdReducer.data?.[0]?.clientProductMapping,
  );
  const trendingProducts = useSelector(
    (state) => state?.trendingGiftCardsReducer,
  );

  const openModal = () => {
    setIsOpen(true);
    setPrevUrl(location.search);
  };
  const handleSortChange = (sortKey) => {
    setSelectedSort(sortKey || "");
    // setPageNumber(1); // Reset to page 1 when sort changes
  };

  // Function to handle clearing sort
  const handleClearSort = () => {
    setSelectedSort("");
    // setPageNumber(1); // Reset to page 1 when sort is cleared
  };

  const closeModal = (e, isCancel = false) => {
    isCancel && navigate(`${location.pathname}${prevUrl.toString()}`);
    setIsOpen(false);
  };

  var trendProd = [];
  if (trending === "true") {
    trendProd = filterByActive(trendingProducts?.data)?.[0]?.products;
  }
  let AllProductData = trending === "true" ? trendProd : productData;
  function filterByActive(data) {
    return data.filter((item) => item.sectionName === trendingProducts?.active);
  }
  useEffect(() => {
    if (AllProductData && productDiscount) {
      const ProductDataWithDiscount = AllProductData.map((product) => {
        const discount = productDiscount.find(
          (data) => data.productId === product.id,
        );
        if (discount) {
          return {
            ...product,
            customerDiscount: discount.customerDiscount,
            clientCommission: discount?.clientCommission,
            convenienceFee: discount?.convenienceFee,
            gst: discount?.gst,
            priceDenomination: discount?.priceDenomination,
          };
        }

        return product;
      });
      setAllProducts(ProductDataWithDiscount);
    }
  }, [productDiscount, AllProductData]);

  const modalRef = useRef(null);

  // Toggle modal visibility
  const toggleModal = () => {
    setDisplaySort((prev) => !prev);
  };

  // Handle clicks outside the modal
  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setDisplaySort(false);
    }
  };

  // Add event listener on mount and cleanup on unmount
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const loginV3Data = LoginV3Data();

  const handleRedeemable = (value) => {
    setCheckedRedeemable(value ? String(value) : "");
    setPageNumber(1);
    disountCheckedCategories(value, "Redeemable");
    // rely on location.search useEffect to refresh the list
  };

  // get discount which is selected
  const handleDiscount = (newDiscount) => {
    setDiscount(newDiscount);
    disountCheckedCategories(newDiscount, "Discount");
    setPageNumber(1); // Reset page number when discount filter changes
  };
  const lastDiscountKey = useRef("");
  function disountCheckedCategories(item, filter_type) {
    if (item === null || item === undefined) {
      return;
    }
    const filters = [];
    if (filter_type === "Redeemable") {
      const RedeemableArray = Array.isArray(item)
        ? item
        : String(item).split(",");

      const discountLabel = RedeemableArray.map((value) => {
        if (value === "online" || value === 1) return "Online";
        if (value === "offline" || value === 2) return "In-Store";
        return "Both";
      });
      filters.push({
        filter_type: filter_type,
        filter_value: discountLabel,
      });
    }
    if (filter_type === "Category") {
      const categoryArray = Array.isArray(item)
        ? item
        : String(item).split(",");
      filters.push({
        filter_type: filter_type,
        filter_value: categoryArray.map((cat) => cat),
      });
    }

    // if (discount != null && Number(discount) > 0 && filter_type === "Discount") {
    if (filter_type === "Discount" && item != null) {
      const discountArray = Array.isArray(item)
        ? item
        : String(item).split(",");
      const key = `Discount:${discountArray.join(",")}`;
      if (lastDiscountKey.current === key) return;
      lastDiscountKey.current = key;
      const discountLabel = discountArray.map((value) => {
        if (value === "1" || value === 1) return "0 to 5%";
        if (value === "2" || value === 2) return "5 to 10%";
        return "Above 10%";
      });

      filters.push({
        filter_type,
        filter_value: discountLabel,
      });
    }

    if (filters.length > 0) {
      trackEvent("filter_applied", {
        filters: filters,
      });
      filter_type = "";
    }
  }
  useEffect(() => {
    dispatch(setFilteredAddSpecialActive(location?.state?.name));
  }, [trendingProducts]);

  // get name of the sortBy in sortByData
  const handleSortBy = (item) => {
    setDisplaySort(false); // Close modal after sorting
  };

  const handleModalData = (item) => {
    setModalData(item);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  // Close search dropdown when clicking outside the search boxes
  useEffect(() => {
    function handleDocumentClick(e) {
      if (!searchTerm) return;
      const insideMain =
        searchContainerRef.current &&
        searchContainerRef.current.contains(e.target);
      const insideModalSearch =
        modalSearchContainerRef.current &&
        modalSearchContainerRef.current.contains(e.target);
      if (!insideMain && !insideModalSearch) {
        setSearchTerm("");
        setIsSearching(false);
        setIsSearchActive(false);
        setSearchFilterList([]);
      }
    }

    document.addEventListener("mousedown", handleDocumentClick);
    return () => document.removeEventListener("mousedown", handleDocumentClick);
  }, [searchTerm]);

  useEffect(() => {
    if (products?.length) {
      trackEvent("view_item_list", {
        page_title: CategoryId ? CategoryId : "products",
        result_count: products?.length,
        items: products?.map((p) => ({
          item_name: p?.name,
          item_id: p?.sku,
          item_category: "giftcards",
          item_category2: CategoryId ? CategoryId : "products",
          item_brand: p?.name,
          item_image: p?.small,
          item_url: window.location.href,
        })),
      });
    }
  }, [products?.length]);
  useEffect(() => {
    if (loginV3Data.memberIdentifier) {
      dispatch(
        onGetCustomerProduct({
          customerId: loginV3Data.memberIdentifier,
        }),
      );
    }
  }, []);
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    let updatedCheckedCategories = checked
      ? [...checkedCategories, name]
      : checkedCategories.filter((cat) => cat !== name);
    // Remove duplicates
    updatedCheckedCategories = [...new Set(updatedCheckedCategories)];
    const updatedCheckedCategoryData = updatedCheckedCategories.flatMap(
      (catName) => (categoryMap[catName] ? [categoryMap[catName]] : []),
    );
    const queryParams = new URLSearchParams(location.search);
    const encryptedDiscountParam = queryParams.get("discountSlab");
    const encryptedredemptionTypeParam =
      queryParams.get("redemptionType") || queryParams.get("redeemable");

    disountCheckedCategories(updatedCheckedCategories, "Category");

    // Update all category states consistently
    setCheckedCategories(updatedCheckedCategories);
    setCategory(updatedCheckedCategoryData);
    setCategoryName(updatedCheckedCategories);
    setDiscount(undefined);
    setPageNumber(1);
    const params = new URLSearchParams(location.search);
    if (updatedCheckedCategories.length > 0) {
      // Conditionally encrypt the categoryId parameter based on environment setting
      const categoryValue = updatedCheckedCategories.join(",");
      const finalCategoryId =
        process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
          ? categoryValue
          : encryptURLParam(categoryValue);
      params.set("categoryId", finalCategoryId);
    } else {
      params.delete("categoryId");
    }
    navigate(`${location.pathname}?${params.toString()}`);
  };
  const handleClick = (item) => {
    dispatch(setProduct(item));
    // Conditionally encrypt the productId parameter based on environment setting
    const productId = item?.id.toString();
    const finalProductId =
      process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? productId
        : encryptURLParam(productId);
    navigate(`/giftcard?productId=${finalProductId}`, { state: { item } });
    setSearchTerm("");
    setFilteredResults([]);
    setIsSearching(false);
    setIsSearchActive(false);
  };
  // useEffect(() => {

  //   const filters = [
  //     {
  //       filter_type: "Category",
  //       filter_value: checkedCategoryName.join(", "),
  //     },
  //   ];
  //   if (discount && Number(discount) > 0) {
  //     filters.push({
  //       filter_type: "Discount",
  //       filter_value: discount,
  //     });
  //   }
  //   trackEvent("filter_applied", {

  //     filter: filters

  //   });
  // }, [handleCheckboxChange, discount]);

  return (
    <>
      <ScrollToTop />
      <div className="container-fluid">
        {showModal && (
          <EarnPointsModal
            modalDataValue={modalData}
            show={showModal}
            modalClass={"filterModal"}
            handleClose={handleClose}
            products={products}
            maxDiscountValue={maxDiscountValue}
          />
        )}
      </div>
      <ScrollToTop />
      <section className="py-xl-3 pt-1 pb-2 mt-5rems pt-6 minhight">
        <div className="container">
          <div className="row listpagerow">
            <div className="col-xl-4 col-md-4 col-12 fil-list fltr-h">
              <div className="listfilterpadd bg-w-p2 mb-2">
                <div
                  className="searchboxmaindiv searchboxleftFilters"
                  ref={searchContainerRef}
                >
                  <div className="searchbox">
                    <a id="btnsearch">
                      <i className="las la-search"></i>
                    </a>
                    <input
                      name="ctl00$txtsearch"
                      type="text"
                      id="txtsearch"
                      className="autosuggest"
                      autoComplete="off"
                      placeholder={placeholder}
                      value={searchTerm}
                      onChange={handleChangeOptimized}
                    />
                    <div
                      class="searchIconRemove"
                      onClick={() => {
                        setSearchTerm("");
                      }}
                    >
                      <i class="fa-solid fa-circle-xmark cursorPointer"></i>
                    </div>
                  </div>
                  {searchTerm && isSearchActive && (
                    <ul className="dropdown1">
                      {searchFilterList?.length > 0 ? (
                        <>
                          {brand_availableMessage && (
                            <li
                              className="dropdown-item"
                              style={{ whiteSpace: "break-spaces" }}
                            >
                              {
                                translation?.This_brand_available_with_the_current_filters
                              }
                            </li>
                          )}
                          {searchFilterList.map((item, index) => (
                            <li
                              onClick={() => handleClick(item)}
                              key={`${item.id}-${index}`}
                              className="dropdown-item d-flex align-item-center"
                            >
                              <i
                                className="las la-search mx-2"
                                style={{ fontSize: "1.5em" }}
                              ></i>
                              {item.name}
                            </li>
                          ))}
                        </>
                      ) : NoResultFoundMessage ? (
                        <li className="dropdown-item">
                          {translation?.NoRecordsFound}
                        </li>
                      ) : null}

                      {hasMoreSearchResults && searchFilterList.length > 0 && (
                        <li
                          ref={searchLoaderRef}
                          className="dropdown-item text-center py-0"
                          style={{ minHeight: "10px" }}
                        >
                          {isLoadingMore ? (
                            <span>Loading more...</span>
                          ) : (
                            <span style={{ display: "none" }}>
                              Load trigger
                            </span>
                          )}
                        </li>
                      )}
                    </ul>
                  )}
                </div>

                <SortBy
                  products={products}
                  onSortChange={handleSortChange}
                  onClearSort={handleClearSort}
                />
                <hr />
                <ClearFilter product={products} setPrevUrl={setPrevUrl} />
                <div className="mb-2 filter-mod">
                  <Redeemable
                    onRedeemable={handleRedeemable}
                    checkedRedeemable={checkedRedeemable}
                    discount={handleDiscount}
                  />
                  <DiscountFilterNew
                    product={products}
                    discount={handleDiscount}
                    setMaxDiscount={setMaxDiscount}
                    setPageNumber={setPageNumber}
                    pageNumber={pageNumber}
                    maxDiscountValue={maxDiscountValue}
                    setCategoryName={categoryName}
                  />
                  {/* <CategoryFilter categoryName={handleCategory} setPageNumber={setPageNumber} /> */}
                  <CategoryFilter
                    checkedCategories={checkedCategories}
                    checkedCategoryName={checkedCategoryName}
                    categoryMap={categoryMap}
                    handleCheckboxChange={handleCheckboxChange}
                  />
                </div>
                {/* <DiscountFilter
                  product={products}
                  discount={handleDiscount}
                  setMaxDiscount={setMaxDiscount}
                  setPageNumber={setPageNumber}
                  maxDiscountValue={maxDiscountValue}
                  setCategoryName={categoryName}
                /> */}
              </div>
            </div>
            <div className="col-xl-8 col-md-8 col-12 ">
              <div className="row1 jcc-mob">
                <TrendingCardHeader
                  product={products}
                  isToggle={location?.state?.isTrending}
                  trendingheading={location?.state?.name}
                  categoryName={categoryName}
                  sortBy={handleSortBy}
                  totalCount={totalCount}
                />
                <div className="row m-xl-n3 m-md-n2 m-n1 mt-4 listpagerow marg-20 p-trend">
                  {loading ? (
                    <CustomLoader />
                  ) : (
                    <TrendingGiftCardOptimized
                      productValues={(item) => handleModalData(item)}
                      handleShow={handleShow}
                      product={products}
                      setPageNumber={setPageNumber}
                      pageNumber={pageNumber}
                      totalCount={totalCount}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Mobile and tab sort and filter  */}
      {!isOpen && !showModal && (
        <div className="listheader desktop-hide" style={{ zIndex: 999999999 }}>
          <nav className="bottom-nav">
            <div className="bottom-nav-item">
              <div
                className="bottom-nav-link"
                // onClick={() => setDisplaySort(!displaySort)}
                onClick={openModal}
              >
                <Link data-bs-toggle="modal" data-bs-target="#sortby">
                  <img
                    src={FilterIcon}
                    alt="filter icon"
                    className="filter-icon"
                  />
                </Link>
                <span className="mobile-filter">
                  {translation?.filterAndSort}
                </span>
              </div>
            </div>
          </nav>
        </div>
      )}
      {/* sort by modal pop pup for mobile and tab */}
      <div>
        {/* Button to toggle modal */}
        {/* <button onClick={toggleModal}>Sort By</button> */}

        {/* Modal */}
        {displaySort && (
          <div
            className={`modal fade ${displaySort ? "filterShowHide" : ""}`}
            id="sortby"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            style={{
              position: "fixed",
              top: "calc(100vh - 309px)",
              width: "100%",
            }}
            ref={modalRef}
          >
            <div className="modal-dialog bordertop">
              <div className="modal-content bordertop">
                <div
                  className="modal-header-custom borderBottomNone"
                  onClick={toggleModal}
                >
                  <span className="modal-btn"></span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* filter modal pop pup for mobile and tab */}
      <div>
        {isOpen && (
          <div className="custom-modal-overlay" onClick={closeModal}>
            <div
              className="custom-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ marginBottom: "1.5rem" }}>
                <div
                  className="searchboxmaindiv searchboxleftFilters"
                  ref={modalSearchContainerRef}
                >
                  <div className="searchbox">
                    <a id="btnsearch">
                      <i className="las la-search"></i>
                    </a>
                    <input
                      name="ctl00$txtsearch"
                      type="text"
                      id="txtsearch"
                      className="autosuggest"
                      autoComplete="off"
                      placeholder={placeholder}
                      value={searchTerm}
                      onChange={handleChangeOptimized}
                    />
                    <div
                      class="searchIconRemove"
                      onClick={() => {
                        setSearchTerm("");
                      }}
                    >
                      <i class="fa-solid fa-circle-xmark cursorPointer"></i>
                    </div>
                  </div>
                  {searchTerm && (
                    <ul className="dropdown1">
                      {searchFilterList?.length > 0 ? (
                        <>
                          {brand_availableMessage && (
                            <li
                              className="dropdown-item"
                              style={{ whiteSpace: "break-spaces" }}
                            >
                              {
                                translation?.This_brand_available_with_the_current_filters
                              }
                            </li>
                          )}
                          {searchFilterList.map((item, index) => (
                            <li
                              onClick={() => handleClick(item)}
                              key={`${item.id}-${index}`}
                              className="dropdown-item d-flex align-item-center"
                            >
                              <i
                                className="las la-search mx-2"
                                style={{ fontSize: "1.5em" }}
                              ></i>
                              {item.name}
                            </li>
                          ))}
                        </>
                      ) : NoResultFoundMessage ? (
                        <li className="dropdown-item">
                          {translation?.NoRecordsFound}
                        </li>
                      ) : null}

                      {hasMoreSearchResults && searchFilterList.length > 0 && (
                        <li
                          ref={searchLoaderRef}
                          className="dropdown-item text-center py-0 "
                          style={{ minHeight: "10px" }}
                        >
                          {isLoadingMore ? (
                            <span>Loading more...</span>
                          ) : (
                            <span style={{ display: "none" }}>
                              Load trigger
                            </span>
                          )}
                        </li>
                      )}
                    </ul>
                  )}
                </div>
                <SortBy
                  products={products}
                  onSortChange={handleSortChange}
                  onClearSort={handleClearSort}
                />
              </div>
              <hr />
              <div className="fixtop">
                <ClearFilter product={products} />
              </div>

              <div className="mb-2 filter-mod">
                <Redeemable discount={handleDiscount} />
                <DiscountFilterNew
                  product={products}
                  discount={handleDiscount}
                  setMaxDiscount={setMaxDiscount}
                  setPageNumber={setPageNumber}
                  maxDiscountValue={maxDiscountValue}
                />
                <CategoryFilter
                  checkedCategories={checkedCategories}
                  checkedCategoryName={checkedCategoryName}
                  categoryMap={categoryMap}
                  handleCheckboxChange={handleCheckboxChange}
                />
              </div>
              <hr />

              <div className="buttons-fixed pl-0">
                <div className="col-lg-12 col-12 mt-2 text-center d-flex justify-content-center">
                  <button
                    className={`filter-button cancel-btn`}
                    onClick={(e) => closeModal(e, true)}
                    style={{ cursor: "pointer" }}
                  >
                    {translation?.cancel}
                  </button>

                  <button
                    className={`filter-button pb-0-1 selected`}
                    onClick={closeModal}
                    style={{ cursor: "pointer" }}
                  >
                    {translation?.apply}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProductListOptimized;
